export default __webpack_public_path__ + "static/media/main-1.4a8c6e5d.jpg";